import React, { SFC } from 'react';
import classNames from 'classnames';
import { getVariable } from 'grpn-mx-mixer';
import styles from './icon.styl';

type IconColor =
  | 'groupon-black'
  | 'groupon-green'
  | 'groupon-gray'
  | 'light-gray'
  | 'link-blue'
  | 'orange'
  | 'red'
  | 'yellow'
  | 'dark-green'
  | 'white';

export interface IconProps {
  size: 64 | 32 | 24 | 16;
  color?: IconColor;
}

interface IconPropsWithSource extends IconProps {
  src: string;
}

export type IconComponent = SFC<IconProps>;

export const Icon: SFC<IconPropsWithSource> = ({ src, size, color }) => {
  const style: React.HTMLAttributes<HTMLSpanElement>['style'] = {
    display: 'inline-block',
    width: size,
    height: size,
  };

  if (color) {
    style.fill = getVariable(`$color-${color}` as any) as string;
  }

  return (
    <span
      className={classNames(styles.root)}
      style={style}
      dangerouslySetInnerHTML={{ __html: src }}
    />
  );
};
